export const AVAILABLE_POOL_TYPE_MAP = {
  STANDARD_POOL: 'Standard Pool',
  STABLE_POOL: 'Stable Pool',
  SINGLE_TOKEN_POOL: 'Single Token Pool',
}
